package com.downdogapp.client.views

import com.downdogapp.*
import com.downdogapp.Size.Companion.px
import com.downdogapp.Size.Companion.vh
import com.downdogapp.TextAlign.CENTER
import com.downdogapp.client.MANIFEST
import com.downdogapp.client.Strings
import com.downdogapp.client.Strings.EXIT
import com.downdogapp.client.View
import com.downdogapp.client.controllers.PostPracticeViewController
import com.downdogapp.client.resources.Images
import com.downdogapp.client.singleton.Network
import com.downdogapp.client.widget.*
import com.downdogapp.client.widget.StructuredRow.Companion.leftIconRow
import org.w3c.dom.HTMLSpanElement

actual class PostPracticeView actual constructor(
  private val controller: PostPracticeViewController
) : TopLevelView(), View {

  private var table: TableView
  private var songAttribution: HTMLSpanElement

  actual override fun refreshView() {
    super.refreshView()
    table.refreshContents()
  }

  override val root =
    controllerView {
      bg = background(image = postPracticeBackgroundImage, blur = true)

      fg = foreground {
        centeredColumnView {
          marginTop = px(80)
          horizontalFlexBox(verticalAlign = AlignItems.CENTER, horizontalJustify = JustifyContent.FLEX_END) {
            songAttribution = label(fontSize = 18, fontWeight = FontWeight.MEDIUM)
          }

          div {
            marginTop = vh(10)

            div {
              textAlign = CENTER

              div {
                marginBottom = px(20)
                marginLeft = px(48)
                marginRight = px(48)

                label(controller.message, 16)
              }

              separator()

              table = tableView(::getContents)

              roundedTextButton(
                text = EXIT,
                marginHorizontal = HORIZONTAL_CONTENT_GUTTER_PX,
                clickFn = controller::onBackClicked
              ) {
                marginTop = px(6)
              }
            }
          }
        }
      }
    }

  actual fun updateSongAttribution(text: String?) {
    songAttribution.text = text
    if (text == null) {
      songAttribution.hide()
    } else {
      songAttribution.show()
    }
  }

  fun getContents() = TableContents(
    rows = listOfNotNull(
      MANIFEST.membershipButtonText?.let {
        if (!Network.isOffline())
          leftIconRow(
            image = Images.SHOPPING_CART,
            text = it,
            fontSize = 14,
            clickFn = controller::membershipClicked
          )
        else
          null
      },
      MANIFEST.practiceFeedbackMessage?.let {
        leftIconRow(
          image = Images.EMAIL,
          text = Strings.SEND_FEEDBACK,
          fontSize = 14,
          clickFn = controller::feedbackClicked
        )
      },
      if (controller.showSongsRow)
        leftIconRow(
          image = Images.SETTINGS_MUSIC,
          text = Strings.SONG_LIST,
          fontSize = 14,
          clickFn = controller::playlistClicked
        )
      else
        null,
      if (controller.showPoseList)
        leftIconRow(
          image = Images.POSE_LIST,
          text = controller.poseListTitle,
          fontSize = 14,
          clickFn = controller::poseListClicked
        )
      else
        null,
      MANIFEST.shareUrl?.let {
        leftIconRow(
          image = Images.SETTINGS_SHARE,
          text = Strings.SHARE_THIS_PRACTICE,
          fontSize = 14,
          clickFn = controller::shareClicked
        )
      },
      if (controller.showFavoriteRow)
        leftIconRow(
          image = Images.HEART,
          text = Strings.FAVORITE,
          fontSize = 14,
          clickFn = controller::saveClicked
        )
      else
        null
    ),
    separator = rightSeparator
  )
}

val postPracticeBackgroundImage get() = Images.LOGIN
